import { Alert, Flex } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import React from 'react'

type Props = {
  isMulti?: boolean
}

const ContractHasRestOnPeriod: FC<Props> = ({ isMulti }) => {
  const { t } = usePlanningFormTranslation()

  return (
    <Flex className='mb-4' data-testid='contract_has_rest_on_period_trick'>
      <Alert intent='semantic.red'>
        {t('restForm.employeeAlreadyHaveRest', { count: isMulti ? 2 : 1 })}
        {t('restForm.employeeWillBeExcluded', { count: isMulti ? 2 : 1 })}
      </Alert>
    </Flex>
  )
}

export default ContractHasRestOnPeriod
